<!-- eslint-disable -->
<template>
  <div class="electronic-insurance-page">
    <!-- 页面标题区域 -->
    <div class="page-header">
      <div class="page-title">
        <h1>电子保单管理</h1>
        <p class="page-description">管理和查看电子保单附件信息</p>
      </div>
    </div>

    <!-- 搜索过滤区域 -->
    <div class="search-section">
      <div class="search-header">
        <div class="search-title">
          <i class="el-icon-search"></i>
          <span>筛选条件</span>
        </div>
        <div class="search-actions">
          <el-button 
            type="text" 
            @click="toggleAdvancedSearch"
            class="toggle-advanced"
          >
            {{ showAdvancedSearch ? '收起' : '高级筛选' }}
            <i :class="showAdvancedSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </el-button>
        </div>
      </div>
      
      <div class="search-content">
        <!-- 基础搜索 -->
        <div class="basic-search">
          <el-form :model="searchData" :inline="true" size="small">
            <el-form-item>
              <el-input 
                v-model="searchData.inquiryNo" 
                placeholder="搜索报价单号" 
                prefix-icon="el-icon-search"
                clearable
                @keyup.enter.native="handleSearch"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input 
                v-model="searchData.mobile" 
                placeholder="搜索手机号" 
                prefix-icon="el-icon-phone"
                clearable
                @keyup.enter.native="handleSearch"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch" :loading="listLoading">
                <i class="el-icon-search"></i>
                搜索
              </el-button>
              <el-button @click="handleReset">
                <i class="el-icon-refresh-left"></i>
                重置
              </el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 高级搜索 -->
        <div class="advanced-search" v-show="showAdvancedSearch">
          <el-form :model="searchData" :inline="true" size="small" label-width="80px">
            <el-form-item label="投保类型">
              <el-select v-model="searchData.businessType" placeholder="选择类型" clearable>
                <el-option label="新保" value="1"></el-option>
                <el-option label="续保" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="险种类型">
              <el-select v-model="searchData.insuranceType" placeholder="选择险种" clearable>
                <el-option label="交强险" value="1"></el-option>
                <el-option label="商业险" value="2"></el-option>
                <el-option label="其他" value="5"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="投保人">
              <el-input v-model="searchData.policyholder" placeholder="输入投保人姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="保险公司">
              <el-input v-model="searchData.orgName" placeholder="输入保险公司" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 操作栏和视图切换 -->
    <div class="action-bar">
      <div class="left-actions">
        <div class="view-toggle">
          <el-button-group>
            <el-button 
              :type="viewMode === 'table' ? 'primary' : 'default'"
              size="small"
              @click="setViewMode('table')"
            >
              <i class="el-icon-menu"></i>
              表格视图
            </el-button>
            <el-button 
              :type="viewMode === 'card' ? 'primary' : 'default'"
              size="small"
              @click="setViewMode('card')"
            >
              <i class="el-icon-copy-document"></i>
              卡片视图
            </el-button>
          </el-button-group>
        </div>
      </div>
      <div class="right-actions">
        <el-button size="small" @click="handleRefresh" :loading="listLoading">
          <i class="el-icon-refresh"></i>
          刷新
        </el-button>
      </div>
    </div>

    <!-- 数据展示区域 -->
    <div class="data-section">
      <!-- 表格视图 -->
      <div class="table-view" v-show="viewMode === 'table'">
        <my-table ref="list" :data="listData" @page="pageHandler" :listLoading="listLoading">
          <template #header></template>
          <el-table-column label="流水号" fixed="left" prop="epNo" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="serial-number">
                <span>{{ scope.row.epNo || '-' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="报价单号" prop="inquiryNo" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="inquiry-number">
                <span class="number-text">{{ scope.row.inquiryNo || '-' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="投保人" prop="policyholder" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="policyholder-info">
                <i class="el-icon-user"></i>
                <span>{{ scope.row.policyholder || '-' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="手机号" prop="mobile" min-width="130" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="mobile-info">
                <i class="el-icon-phone"></i>
                <span>{{ scope.row.mobile || '-' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="投保类型" prop="businessType" width="100" align="center">
            <template slot-scope="scope">
              <el-tag 
                :type="scope.row.businessType === 1 ? 'primary' : 'success'"
                size="small"
                effect="light"
              >
                {{ scope.row.businessType | businessTypeFilter }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="车牌" prop="licensePlate" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="license-plate">
                <span>{{ scope.row.licensePlate || '-' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="险种类型" prop="insuranceType" width="100" align="center">
            <template slot-scope="scope">
              <el-tag 
                :type="getInsuranceTypeTagType(scope.row.insuranceType)"
                size="small"
                effect="light"
              >
                {{ scope.row.insuranceType | insuranceTypeFilter }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="保险公司" prop="orgName" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="org-name">
                <i class="el-icon-office-building"></i>
                <span>{{ scope.row.orgName || '-' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="地区" prop="regionDesc" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="创建时间" prop="ctime" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="create-time">
                <span>{{ scope.row.ctime || '-' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="120" align="center">
            <template slot-scope="scope">
              <el-button 
                type="primary" 
                size="mini" 
                @click="view(scope.row)"
                :loading="scope.row.loading"
              >
                <i class="el-icon-view"></i>
                附件
              </el-button>
            </template>
          </el-table-column>
          
          <!-- 空数据提示 - 表格版 -->
          <template #empty>
            <div class="table-empty-state">
              <div class="empty-icon">
                <i class="el-icon-document-delete"></i>
              </div>
              <div class="empty-text">
                <p>暂无电子保单数据</p>
                <span>请尝试调整筛选条件或联系管理员</span>
              </div>
            </div>
          </template>
        </my-table>
      </div>

      <!-- 卡片视图 -->
      <div class="card-view" v-show="viewMode === 'card'">
        <div class="card-grid">
          <div 
            class="insurance-card" 
            v-for="item in listData" 
            :key="item.epNo"
            @click="view(item)"
          >
            <div class="card-header">
              <div class="card-title">
                <i class="el-icon-document"></i>
                <span class="serial-number">{{ item.epNo || '-' }}</span>
              </div>
              <div class="card-actions">
                <el-tag 
                  :type="item.businessType === 1 ? 'primary' : 'success'"
                  size="mini"
                  effect="light"
                >
                  {{ item.businessType | businessTypeFilter }}
                </el-tag>
              </div>
            </div>
            
            <div class="card-body">
              <div class="info-row">
                <span class="label">报价编号：</span>
                <span class="value">{{ item.inquiryNo || '-' }}</span>
              </div>
              <div class="info-row">
                <span class="label">投保人：</span>
                <span class="value">
                  <i class="el-icon-user"></i>
                  {{ item.policyholder || '-' }}
                </span>
              </div>
              <div class="info-row">
                <span class="label">手机号：</span>
                <span class="value">
                  <i class="el-icon-phone"></i>
                  {{ item.mobile || '-' }}
                </span>
              </div>
              <div class="info-row">
                <span class="label">车牌号：</span>
                <span class="value">
                  <i class="el-icon-truck"></i>
                  {{ item.licensePlate || '-' }}
                </span>
              </div>
              <div class="info-row">
                <span class="label">险种类型：</span>
                <span class="value">
                  <el-tag 
                    :type="getInsuranceTypeTagType(item.insuranceType)"
                    size="mini"
                    effect="plain"
                  >
                    {{ item.insuranceType | insuranceTypeFilter }}
                  </el-tag>
                </span>
              </div>
              <div class="info-row">
                <span class="label">保险公司：</span>
                <span class="value">
                  <i class="el-icon-office-building"></i>
                  {{ item.orgName || '-' }}
                </span>
              </div>
            </div>
            
            <div class="card-footer">
              <div class="footer-info">
                <i class="el-icon-time"></i>
                <span>{{ item.ctime || '-' }}</span>
              </div>
              <div class="footer-actions">
                <el-button 
                  type="primary" 
                  size="mini" 
                  :loading="item.loading"
                >
                  <i class="el-icon-view"></i>
                  查看附件
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- 空数据提示 -->
        <div class="empty-state" v-if="!listLoading && listData.length === 0">
          <div class="empty-icon">
            <i class="el-icon-document-delete"></i>
          </div>
          <div class="empty-text">
            <p>暂无电子保单数据</p>
            <span>请尝试调整筛选条件</span>
          </div>
        </div>

        <!-- 分页组件 -->
        <div class="pagination-wrapper" v-if="listData.length > 0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageData.num"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageData.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 附件预览对话框 -->
    <pdf-preview
      :visible.sync="previewPdfDialogVisible"
      :pdf-url="previewPdf"
      title="电子保单附件预览"
    ></pdf-preview>
  </div>
</template>

<script>
/* eslint-disable */
import FileUpload from "@/components/scope/file-upload.vue";
import Template from "@/views/dashboard/template.vue";
import PdfPreview from "@/components/scope/pdf-preview.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: { Template, FileUpload, PdfPreview },
  data() {
    //这里存放数据
    return {
      listData: [],
      // 搜索数据
      searchData: {
        insuranceType: null,
        inquiryNo: null,
        businessType: null,
        mobile: null,
        orgName: null,
        policyholder: null
      },
      listLoading: false,
      pageData: {
        num: 1,
        size: 10,
        total: 0
      },
      previewPdf: '',
      previewPdfDialogVisible: false,
      // 视图模式控制
      viewMode: 'table', // 'table' 或 'card'
      showAdvancedSearch: false // 高级搜索展开状态
    };
  },
  filters: {
    businessTypeFilter(val) {
      switch (val) {
        case 1:
          return "新保";
        case 2:
          return "续保";
      }
      return "-"
    },
    insuranceTypeFilter(val) {
      switch (val) {
        case 1:
          return "交强险";
        case 2:
          return "商业险";
        case 5:
          return "其他";
      }
      return "-"
    },
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 视图模式切换
    setViewMode(mode) {
      this.viewMode = mode;
      // 可以在这里添加本地存储逻辑
      localStorage.setItem('insurance-view-mode', mode);
    },
    
    // 切换高级搜索
    toggleAdvancedSearch() {
      this.showAdvancedSearch = !this.showAdvancedSearch;
    },
    
    // 搜索操作
    handleSearch() {
      this.pageData.num = 1;
      // 如果使用的是my-table组件，需要通过$refs来触发
      if (this.$refs.list) {
        this.pageHandler(this.$refs.list, 1);
      } else {
        this.getDataList({}, 1, this.pageData.size);
      }
    },
    
    // 重置搜索
    handleReset() {
      this.resetSearchData();
      this.pageData.num = 1;
      // 如果使用的是my-table组件，需要通过$refs来触发
      if (this.$refs.list) {
        this.pageHandler(this.$refs.list, 1, 'reset');
      } else {
        this.getDataList({}, 1, this.pageData.size);
      }
    },
    
    // 刷新数据
    handleRefresh() {
      // 如果使用的是my-table组件，需要通过$refs来触发
      if (this.$refs.list) {
        this.pageHandler(this.$refs.list, this.pageData.num);
      } else {
        this.getDataList({}, this.pageData.num, this.pageData.size);
      }
    },
    
    // 分页大小变化
    handleSizeChange(size) {
      this.pageData.size = size;
      this.pageData.num = 1;
      // 使用my-table组件的分页机制
      if (this.$refs.list && this.viewMode === 'table') {
        this.pageHandler(this.$refs.list, 1);
      } else {
        // 卡片视图直接调用数据获取方法
        this.getDataList({}, 1, size);
      }
    },
    
    // 页码变化
    handleCurrentChange(page) {
      this.pageData.num = page;
      // 使用my-table组件的分页机制
      if (this.$refs.list && this.viewMode === 'table') {
        this.pageHandler(this.$refs.list, page);
      } else {
        // 卡片视图直接调用数据获取方法
        this.getDataList({}, page, this.pageData.size);
      }
    },
    
    // 获取险种类型标签颜色
    getInsuranceTypeTagType(type) {
      switch (type) {
        case 1:
          return 'warning'; // 交强险
        case 2:
          return 'success'; // 商业险
        case 5:
          return 'info'; // 其他
        default:
          return 'info';
      }
    },
    
    // 更新统计数据
    updateStats() {
      if (this.listData && this.listData.length > 0) {
        const newInsurance = this.listData.filter(item => item.businessType === 1).length;
        const renewInsurance = this.listData.filter(item => item.businessType === 2).length;
        
        this.statsData = {
          total: this.pageData.total,
          newInsurance: newInsurance,
          renewInsurance: renewInsurance,
          todayCount: 0 // 这里可以根据实际需求计算今日新增
        };
      } else {
        // 无数据时的统计
        this.statsData = {
          total: this.pageData.total,
          newInsurance: 0,
          renewInsurance: 0,
          todayCount: 0
        };
      }
    },
    pageHandler(params, num, type) {
      if (type == 'reset') {
        this.resetSearchData();
      }
      this.getDataList(params, num ? num : params.pageNum, params.pageSize);
    },
    
    // 重置搜索数据
    resetSearchData(e) {
      this.searchData = {
        insuranceType: '',
        inquiryNo: '',
        businessType: '',
        mobile: '',
        orgName: '',
        policyholder: ''
      }
    },

    getDataList(params, pageNum, pageSize) {
      this.listLoading = true;
      console.log('开始获取数据，参数：', {
        searchData: this.searchData,
        pageNum: pageNum || this.pageData.num,
        pageSize: pageSize || this.pageData.size
      });
      
      this.$store.dispatch('insurance/getElectronicPolicyList', {
        ...this.searchData,
        pageNum: pageNum || this.pageData.num,
        pageSize: pageSize || this.pageData.size,
      }).then(res => {
        console.log('接口返回数据：', res);
        
        if (res && res.code == 0) {
          this.listData = (res.data && res.data.list) || [];
          this.pageData.total = (res.data && res.data.total) || 0;
          this.pageData.num = pageNum || this.pageData.num;
          this.pageData.size = pageSize || this.pageData.size;
          
          // 如果是my-table组件的回调
          if (params && params.render) {
            params.render((res.data && res.data.total) || 0);
          }
          
          console.log('数据更新完成：', {
            listData: this.listData,
            pageData: this.pageData
          });
        } else {
          console.warn('接口返回异常：', res);
          this.$message.warning((res && res.message) || '获取数据失败');
          this.listData = [];
          this.pageData.total = 0;
        }
        
        this.listLoading = false;
      }).catch(error => {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败，请检查网络连接');
        this.listLoading = false;
        this.listData = [];
        this.pageData.total = 0;
      })
    },
    
    view(row) {
      console.log(row)
      // 设置加载状态
      this.$set(row, 'loading', true);
      
      setTimeout(() => {
        this.previewPdf = row.pkl;
        this.previewPdfDialogVisible = true;
        this.$set(row, 'loading', false);
      }, 300);
    },
    
    previewPdfClose() {
      this.previewPdfDialogVisible = false;
      this.previewPdf = '';
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // 恢复上次的视图模式
    const savedViewMode = localStorage.getItem('insurance-view-mode');
    if (savedViewMode && ['table', 'card'].includes(savedViewMode)) {
      this.viewMode = savedViewMode;
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // 初始化加载数据
    this.$nextTick(() => {
      if (this.$refs.list) {
        this.pageHandler(this.$refs.list, 1);
      } else {
        this.getDataList({}, 1, this.pageData.size);
      }
    });
  },
  //生命周期 - 创建之前
  beforeCreate() {},
  //生命周期 - 挂载之前
  beforeMount() {},
  //生命周期 - 更新之前
  beforeUpdate() {},
  //生命周期 - 更新之后
  updated() {},
  //生命周期 - 销毁之前
  beforeDestroy() {},
  //生命周期 - 销毁完成
  destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/var.scss';
@import '@/assets/css/mixin.scss';

// ===== 响应式断点 =====
$mobile: 768px;
$tablet: 1024px;
$desktop: 1200px;

// ===== 主容器样式 =====
.electronic-insurance-page {
  min-height: 100vh;
  background: $primary-bg;
  padding: 0;

  // ===== 页面标题区域 =====
  .page-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: $white;
    padding: 32px 24px;
    margin-bottom: 24px;

    .page-title {
      h1 {
        font-size: 28px;
        font-weight: 600;
        margin: 0 0 8px 0;
        line-height: 1.2;
      }

      .page-description {
        font-size: 14px;
        opacity: 0.9;
        margin: 0;
        line-height: 1.4;
      }
    }

    @media (max-width: $mobile) {
      padding: 20px 16px;
      
      .page-title h1 {
        font-size: 24px;
      }
    }
  }

  // ===== 搜索区域 =====
  .search-section {
    background: $white;
    border-radius: 12px;
    margin: 0 24px 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid $line-color;
    overflow: hidden;

    .search-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 24px;
      border-bottom: 1px solid $line-color;
      background: #fafbfc;

      .search-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-weight: 600;
        color: $gray1;
        font-size: 16px;

        i {
          color: $primary;
        }
      }

      .toggle-advanced {
        color: $primary;
        font-size: 14px;
        
        i {
          margin-left: 4px;
        }
      }
    }

    .search-content {
      .basic-search {
        padding: 24px;

        .el-form {
          .el-form-item {
            margin-bottom: 0;
            margin-right: 16px;

            .el-input {
              width: 240px;
            }

            .el-button {
              padding: 10px 20px;
              font-weight: 500;
              border-radius: 6px;

              & + .el-button {
                margin-left: 8px;
              }

              i {
                margin-right: 4px;
              }
            }
          }
        }
      }

      .advanced-search {
        padding: 0 24px 24px;
        border-top: 1px solid $line-color;
        background: #fafbfc;
        
        .el-form {
          padding-top: 20px;
          
          .el-form-item {
            margin-bottom: 16px;
            margin-right: 24px;

            .el-form-item__label {
              font-weight: 500;
              color: $gray2;
            }

            .el-input,
            .el-select {
              width: 200px;
            }
          }
        }
      }
    }

    @media (max-width: $mobile) {
      margin: 0 16px 16px;
      
      .search-header {
        padding: 16px;
      }
      
      .basic-search,
      .advanced-search {
        padding: 16px;
        
        .el-form {
          .el-form-item {
            margin-right: 0;
            margin-bottom: 16px;
            width: 100%;
            
            .el-input,
            .el-select {
              width: 100%;
            }
          }
        }
      }
    }
  }

  // ===== 操作栏 =====
  .action-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: $white;
    padding: 16px 24px;
    margin: 0 24px 16px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid $line-color;

    .left-actions {
      .view-toggle {
        .el-button-group {
          .el-button {
            padding: 8px 16px;
            font-weight: 500;
            border-radius: 6px;
            
            i {
              margin-right: 4px;
            }
            
            &:first-child {
              border-top-right-radius: 0;
              border-bottom-right-radius: 0;
            }
            
            &:last-child {
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
            }
          }
        }
      }
    }

    .right-actions {
      .el-button {
        padding: 8px 16px;
        font-weight: 500;
        border-radius: 6px;
        
        i {
          margin-right: 4px;
        }
      }
    }

    @media (max-width: $mobile) {
      margin: 0 16px 16px;
      padding: 12px 16px;
      flex-direction: column;
      gap: 12px;
      
      .left-actions,
      .right-actions {
        width: 100%;
      }
    }
  }

  // ===== 数据展示区域 =====
  .data-section {
    margin: 0 24px;

    // 表格视图样式
    .table-view {
      ::v-deep .el-table {
        background: $white;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        border: 1px solid $line-color;

        &::before {
          display: none;
        }

        .el-table__header {
          th {
            background: #fafbfc;
            color: $gray1;
            font-weight: 600;
            height: 56px;
            padding: 0;
            border-bottom: 2px solid $line-color;
            font-size: 14px;
          }
        }

        .el-table__body {
          td {
            padding: 16px 0;
            color: $gray2;
            border-bottom: 1px solid $line-color;
            font-size: 14px;

            &:last-child {
              border-bottom: none;
            }

            // 自定义列样式
            .serial-number,
            .inquiry-number,
            .policyholder-info,
            .mobile-info,
            .license-plate,
            .org-name,
            .create-time {
              display: flex;
              align-items: center;
              gap: 8px;

              i {
                color: $primary;
                font-size: 16px;
              }
            }

            .number-text {
              font-family: 'Monaco', 'Consolas', monospace;
              font-weight: 500;
            }
          }
        }

        .el-table__fixed,
        .el-table__fixed-right {
          box-shadow: none;
          border-radius: 0;
        }

        .el-button {
          padding: 6px 12px;
          font-size: 12px;
          border-radius: 6px;
          font-weight: 500;
          
          i {
            margin-right: 4px;
          }
        }
        
        // 表格空状态样式
        .table-empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 60px 20px;
          
          .empty-icon {
            font-size: 48px;
            color: $gray4;
            margin-bottom: 16px;
          }
          
          .empty-text {
            text-align: center;
            
            p {
              font-size: 16px;
              color: $gray2;
              margin: 0 0 8px 0;
              font-weight: 500;
            }
            
            span {
              font-size: 14px;
              color: $gray3;
            }
          }
        }
      }
    }

    // 卡片视图样式
    .card-view {
      .card-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
        gap: 20px;

        .insurance-card {
          background: $white;
          border-radius: 12px;
          border: 1px solid $line-color;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
          overflow: hidden;
          transition: all 0.3s ease;
          cursor: pointer;

          &:hover {
            transform: translateY(-4px);
            box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
            border-color: $primary;
          }

          .card-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px 20px;
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
            border-bottom: 1px solid $line-color;

            .card-title {
              display: flex;
              align-items: center;
              gap: 8px;
              font-weight: 600;
              color: $gray1;
              font-size: 16px;

              i {
                color: $primary;
                font-size: 18px;
              }

              .serial-number {
                font-family: 'Monaco', 'Consolas', monospace;
              }
            }
          }

          .card-body {
            padding: 20px;

            .info-row {
              display: flex;
              align-items: center;
              margin-bottom: 12px;
              font-size: 14px;

              &:last-child {
                margin-bottom: 0;
              }

              .label {
                flex-shrink: 0;
                width: 80px;
                color: $gray3;
                font-weight: 500;
              }

              .value {
                flex: 1;
                color: $gray1;
                display: flex;
                align-items: center;
                gap: 6px;

                i {
                  color: $primary;
                  font-size: 14px;
                }
              }
            }
          }

          .card-footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px 20px;
            background: #fafbfc;
            border-top: 1px solid $line-color;

            .footer-info {
              display: flex;
              align-items: center;
              gap: 6px;
              color: $gray3;
              font-size: 12px;

              i {
                color: $gray3;
              }
            }

            .footer-actions {
              .el-button {
                padding: 6px 12px;
                font-size: 12px;
                border-radius: 6px;
                
                i {
                  margin-right: 4px;
                }
              }
            }
          }
        }
      }

      // 空数据状态
      .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 80px 20px;
        background: $white;
        border-radius: 12px;
        border: 1px solid $line-color;

        .empty-icon {
          font-size: 64px;
          color: $gray4;
          margin-bottom: 16px;
        }

        .empty-text {
          text-align: center;

          p {
            font-size: 16px;
            color: $gray2;
            margin: 0 0 8px 0;
            font-weight: 500;
          }

          span {
            font-size: 14px;
            color: $gray3;
          }
        }
      }

      // 分页样式
      .pagination-wrapper {
        margin-top: 24px;
        padding: 20px;
        background: $white;
        border-radius: 12px;
        border: 1px solid $line-color;
        text-align: center;

        ::v-deep .el-pagination {
          .el-pagination__total,
          .el-pagination__jump {
            color: $gray2;
            font-weight: 500;
          }

          .el-pager li {
            color: $gray2;
            font-weight: 500;
            border-radius: 6px;
            margin: 0 2px;

            &.active {
              background: $primary;
              color: $white;
            }

            &:hover {
              color: $primary;
            }
          }

          .btn-prev,
          .btn-next {
            border-radius: 6px;
            font-weight: 500;
          }

          .el-select {
            .el-input__inner {
              border-radius: 6px;
            }
          }
        }
      }

      @media (max-width: $mobile) {
        .card-grid {
          grid-template-columns: 1fr;
          gap: 16px;
        }
        
        .insurance-card .card-body .info-row {
          flex-direction: column;
          align-items: flex-start;
          gap: 4px;
          
          .label {
            width: auto;
          }
        }
      }
    }

    @media (max-width: $mobile) {
      margin: 0 16px;
    }
  }

  // ===== 响应式表格优化 =====
  @media (max-width: $tablet) {
    .data-section .table-view {
      ::v-deep .el-table {
        .el-table__header th,
        .el-table__body td {
          padding: 12px 8px;
          font-size: 13px;
        }
        
        // 隐藏不重要的列
        .el-table-column--selection,
        .hidden-sm-and-down {
          display: none;
        }
      }
    }
  }

  @media (max-width: $mobile) {
    .data-section .table-view {
      ::v-deep .el-table {
        font-size: 12px;
        
        .el-table__header th {
          padding: 8px 6px;
        }
        
        .el-table__body td {
          padding: 10px 6px;
        }
      }
    }
  }
}

// ===== 动画效果 =====
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
  max-height: 200px;
  overflow: hidden;
}

.slide-down-enter,
.slide-down-leave-to {
  max-height: 0;
  opacity: 0;
}

// ===== 打印样式 =====
@media print {
  .electronic-insurance-page {
    .page-header,
    .search-section,
    .action-bar {
      display: none;
    }
    
    .data-section {
      margin: 0;
      
      .card-view {
        .insurance-card {
          break-inside: avoid;
          box-shadow: none;
          border: 1px solid #ddd;
        }
      }
    }
  }
}
</style>
